import { render } from "./linkMenu.vue?vue&type=template&id=3283f044&scoped=true"
import script from "./linkMenu.vue?vue&type=script&lang=js"
export * from "./linkMenu.vue?vue&type=script&lang=js"

import "./linkMenu.vue?vue&type=style&index=0&id=3283f044&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3283f044"]])

export default __exports__